function searchQuery(name) {
  return encodeURIComponent(
    name.toLowerCase()
      .replace(/\b\d+\s*(ml|l|g|kg|mg|mcg|iu|x\s*\d+)\b/gi, '')
      .replace(/\b\d+\s*(tablets?|capsules?|sachets?|serves?|pack|pieces?|sheets?|wipes?)\b/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim()
      .split(/\s+/)
      .slice(0, 3)
      .join(' ')
  );
}

export function storeLink(deal) {
  const q      = encodeURIComponent(deal.name.toLowerCase());
  const shortQ = searchQuery(deal.name.toLowerCase());
  switch (deal.store) {
    case 'Coles':
      return `https://www.coles.com.au/search?q=${q}&filter_Special=halfprice`;
    case 'Woolworths':
      return `https://www.woolworths.com.au/shop/search/products?searchTerm=${q}`;
    case 'Aldi':
      if (deal.catalogueDate) {
        const today = new Date(new Date().toDateString());
        const saleDay = new Date(deal.catalogueDate + 'T00:00:00');
        return saleDay >= today
          ? `https://www.aldi.com.au/special-buys/${deal.catalogueDate}`
          : 'https://www.aldi.com.au/special-buys/';
      }
      return 'https://www.aldi.com.au/products/super-savers/';
    case 'Chemist Warehouse':
      return `https://www.chemistwarehouse.com.au/search?query=${shortQ}&contexts=default`;
    default:
      return null;
  }
}
